import {Section} from "./styles"

export default function Hire(props) {
  return (
    <Section>
      <h2>Estou disponível para freelancer</h2>
      <a href="https://wa.me/32984527181" target="_blank" rel="noreferrer">
        <button>Contrate-me</button>
      </a>
    </Section>
  );
}
